import React, {Component} from 'react';
import {frameRequestService, langService} from "../services/lang.service";

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      language: '',
      frameRender: false
    }
  }

  renderSwitch = (data) => {
    switch (data) {
      case 'ka':
        return 'Copyright © 2016-2019 Crocobet.com. ყველა უფლება დაცულია.';
      case 'en':
        return 'Copyright © 2016-2019 Crocobet.com. All rights reserved.';
      case 'ru':
        return 'Copyright © 2016-2019 Crocobet.com. Все права защищены.';
      default:
        return 'Copyright © 2016-2019 Crocobet.com. ყველა უფლება დაცულია.';
    }
  };

  componentDidMount() {
    this.langSubscribe = langService.getLang().subscribe(lang => {
      this.setState({
        language: lang.lang
      });
    });

    this.frameSubscribe = frameRequestService.getFrame().subscribe(req => {
      this.setState({
        frameRender: req.frame
      })
    });
  }

  componentWillUnmount() {
    this.langSubscribe.unsubscribe();
    this.frameSubscribe.unsubscribe();
  }

  render() {
    const {language, frameRender} = this.state;

    return (
      frameRender
        ? null
        : <div className="container">
          <div className="row">
            <div className="footer-area">
              <div className="copy">{language
                ? this.renderSwitch(language)
                : 'no lang'
              }</div>
            </div>
          </div>
        </div>
    );
  }

}

export default Footer;
